import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import {
  ArrowsDiv,
  DetailsDiv,
  GlavniImg,
  HorizonDiv,
  ImgDiv,
  InfoDiv,
  MainDiv,
  SoldLabel,
} from "./styled";

import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { products } from "../paintings/products"; // путь под себя

export const ProductStr = () => {
  const { id } = useParams();
  const [imgSlide, setImgSlide] = useState(0);
  const lang = localStorage.getItem("lang") || "en";

  // Находим продукт по ID
  const product = useMemo(
    () => products.find((p) => String(p._id) === String(id)),
    [id]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    setImgSlide(0);
  }, [id]);

  const isSold = product?.instock === false;

  const soldText =
    lang === "ru" ? "ПРОДАНО" : lang === "am" ? "ՎԱՃԱՌՎԱԾ" : "SOLD";

  // ===== Таймер (если нужен) =====
  const calculateTimeLeft = () => {
    if (!product?.timer) return {};
    const difference = +new Date(product.timer) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  const formatTimeComponent = (v) => (v < 10 ? `0${v}` : v);

  const timerComponents = Object.keys(timeLeft).map((key, index, arr) => {
    if (!timeLeft[key]) return null;
    return (
      <span key={key}>
        {formatTimeComponent(timeLeft[key])}
        {index < arr.length - 1 ? ":" : ""}
      </span>
    );
  });

  // ===== Слайдер =====
  const slideLeft = () => {
    if (!product) return;
    setImgSlide((prev) => (prev === 0 ? product.imgs.length - 1 : prev - 1));
  };

  const slideRight = () => {
    if (!product) return;
    setImgSlide((prev) =>
      prev === product.imgs.length - 1 ? 0 : prev + 1
    );
  };

  const getText = (ru, en, am) => {
    if (lang === "ru") return ru;
    if (lang === "am") return am;
    return en;
  };

  if (!product) {
    return <MainDiv>Product not found</MainDiv>;
  }

  return (
    <MainDiv>
      {/* Главное изображение */}
      <GlavniImg $sold={isSold}>
        <img src={product.imgs[0]} alt={product.titleEN} />
      </GlavniImg>

      {/* Галерея */}
      <DetailsDiv>
        <span>DETAILS</span>
        <ImgDiv $sold={isSold}>
          <ArrowsDiv onClick={slideLeft}>
            <span>
              <IoIosArrowBack />
            </span>
          </ArrowsDiv>

          <img src={product.imgs[imgSlide]} alt={product.titleEN} />

          <ArrowsDiv onClick={slideRight}>
            <span>
              <IoIosArrowForward />
            </span>
          </ArrowsDiv>
        </ImgDiv>
      </DetailsDiv>

      {/* Horizon */}
      <HorizonDiv $sold={isSold}>
        <span>HORIZON</span>
        {isSold && <SoldLabel $small>{soldText}</SoldLabel>}
        <img src={product.imgs[0]} alt="Horizon" />
      </HorizonDiv>

      {/* Информация */}
      <InfoDiv>
        <p>
          <span>
            {getText(
              product.descriptionRU,
              product.descriptionEN,
              product.descriptionAM
            )}
          </span>
        </p>

        <p>
          <span>
            {getText(
              product.yuxanerkRU,
              product.yuxanerkEN,
              product.yuxanerkAM
            )}
          </span>
        </p>

        <p>
          <span>
            {getText(product.ktavRU, product.ktavEN, product.ktavAM)}
          </span>
        </p>

        <p>
          <span>{product.size}</span>
        </p>

        {timerComponents.length ? timerComponents : null}
      </InfoDiv>
    </MainDiv>
  );
};
